import React, { useState } from 'react';
import { X } from 'lucide-react';

interface SuccessMessageProps {
  message: string;
}

export default function SuccessMessage({ message }: SuccessMessageProps) {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
      <div className="flex justify-between items-center">
        <p className="text-green-700">{message}</p>
        <button
          onClick={() => setIsVisible(false)}
          className="text-green-500 hover:text-green-700"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}